import React from 'react'
import { FormGroup, TextField, Typography } from '@mui/material'
import update from 'immutability-helper'
import { initRule } from '../../../lib/rule'
import { formUpdate } from '../../../lib/form'
import AccordionPreset from './AccordionPreset'

const name = 'nomx'

const initPreset = {
  name,
  winPoint: 7,
  loseBatsu: 3,
  winPlayers: 0
}

const Nomx = ({ accordionExpanded, onAccordionChange, rule, setRule }) => {
  const [form, setForm] = React.useState(initPreset)
  const change = formUpdate(setForm)

  React.useEffect(() => {
    setForm((rule.preset && rule.preset.name === name) ? rule.preset : initPreset)
  }, [rule.preset])

  const submit = () => {
    const newRule = update(initRule, {
      player: {
        winPlayers: { $set: form.winPlayers },
        winPoint: { value: { $set: form.winPoint } },
        loseBatsu: { value: { $set: form.loseBatsu } }
      },
      preset: { $set: form }
    })
    setRule(newRule)
  }

  return (
    <AccordionPreset name={name} label="N◯ M×" onSubmit={submit}
                     accordionExpanded={accordionExpanded === name}
                     onAccordionChange={onAccordionChange(name)}>
      <Typography variant="body2">
        N ポイント以上で勝抜, M バツ以上で失格です.
      </Typography>
      <FormGroup row={true} className="mt-5">
        <TextField type="number" variant="standard"
                   label="勝抜ポイント" className="win-point"
                   inputProps={{ required: true, min: 1 }}
                   value={form.winPoint}
                   onChange={change.number(value => ({ winPoint: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="失格バツ" className="lose-batsu ml-10"
                   inputProps={{ required: true, min: 1 }}
                   value={form.loseBatsu}
                   onChange={change.number(value => ({ loseBatsu: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="勝抜人数" className="win-players ml-10"
                   inputProps={{ required: true, min: 0 }}
                   value={form.winPlayers}
                   onChange={change.number(value => ({ winPlayers: { $set: value } }))} />
      </FormGroup>
    </AccordionPreset>
  )
}

export default Nomx
